import {
  Card,
  CardHeader,
  CardContent,
  withStyles,
  IconButton,
} from "@material-ui/core";
import { EditOutlined } from "@material-ui/icons";
import Tooltip from "../../../../../common/StyledToolTip";
import appConstants from "../../../../../../appConstants";
import { memo } from "react";

const styles = (theme) => ({
  root: {
    maxWidth: 390,
    minWidth: 370,
    marginBottom: 16,
    backgroundColor: theme.ModalBGColor,
    cursor: "pointer",
  },
  highlightedCard: {
    border: `2px solid ${theme.HeaderSelectedText}`,
    boxShadow: "0 14px 28px rgba(0,0,0,0.25)",
  },
  editIconBg: {
    backgroundColor: theme.infoBGColor,
    "&:hover": {
      backgroundColor: theme.infoBGColor,
    },
  },
  editOutlinedIcon: {
    color: theme.infoTextColor,
    fontSize: 18,
  },
  cardTitle: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
  },
  cardSubHeader: {
    fontSize: theme.headerTextFontSize,
    color: theme.TextColor,
    backgroundColor: theme.ModalBGColor,
  },
  cardHeaderColorContainer: {
    height: 8,
  },
  cardContent: {
    padding: "0px 0px 0px 16px",
    lineHeight: 1.5,
    backgroundColor: theme.ModalBGColor,
  },
  secondaryRouteValues: {
    color: theme.TextColor,
  },
  areaContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    height: 20,
    borderRadius: "10px",
    backgroundColor: theme.HeaderSelectedText,
    color: theme.white,
  },
  disableIcon: {
    cursor: "not-allowed",
    backgroundColor: theme.ToggleDisableIconColor,
    opacity: 0.5,
  },
  typeContainer: {
    display: "flex",
    marginTop: 12,
  },
  deliveryTypeClass: {
    fontSize: theme.textFontSize,
    width: "20px",
    height: "20px",
    borderRadius: 10,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginLeft: 15,
    color: theme.HeaderSelectedText,
    border: "solid 1px",
  },
  pickupTypeClass: {
    fontSize: theme.textFontSize,
    width: "20px",
    height: "20px",
    background: theme.HeaderSelectedText,
    color: theme.white,
    borderRadius: "1px",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginLeft: 15,
  },
  doorContainer: {
    marginTop: 12,
  },
});
const RouteMappingCard = ({
  classes,
  openForm,
  data,
  isEditable,
  isSelectedOnMap,
  selectPolygonOnMap,
  showDoorNumber
}) => {
  const openEdit = () => {
    isEditable && openForm(data.routeMappingId);
  };
  return (
    <Card
      onClick={() => selectPolygonOnMap([data.routeMappingId])}
      className={`${classes.root} ${
        isSelectedOnMap ? classes.highlightedCard : ""
      }`}
    >
      <div
        className={classes.cardHeaderColorContainer}
        style={{ backgroundColor: data.color }}
      ></div>
      <CardHeader
        classes={{
          title: classes.cardTitle,
          subheader: classes.cardSubHeader,
        }}
        action={
          <Tooltip
            title={
              isEditable
                ? "Edit route mapping area"
                : "Select route mapping to edit"
            }
          >
            <IconButton
              onClick={openEdit}
              classes={{ root: classes.editIconBg }}
              className={isEditable ? classes.editIconBg : classes.disableIcon}
            >
              <EditOutlined
                className={isEditable ? classes.editOutlinedIcon : ""}
              />
            </IconButton>
          </Tooltip>
        }
        title="Primary Route Name"
        subheader={data.primaryRouteName}
      />
      <CardContent classes={{ root: classes.cardContent }}>
        <div className={classes.cardTitle}>Secondary Route Name</div>
        <div className={classes.secondaryRouteValues}>
          {data.secondaryRouteName?.split(",").join(" ")}
        </div>
        {showDoorNumber && (
          <div className={classes.doorContainer}>
            <div className={classes.cardTitle}>Door #</div>
            <div className={classes.secondaryRouteValues}>{data?.door}</div>
          </div>
        )}
        <div className={classes.typeContainer}>
          <div id="areaContainer" className={classes.areaContainer}>
            Area: {data.area} mi^2
          </div>
          <div
            className={
              data.type === appConstants.STOP_TYPE.Delivery
                ? classes.deliveryTypeClass
                : classes.pickupTypeClass
            }
          >
            {data.type === appConstants.STOP_TYPE.Delivery ? "D" : "P"}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default memo(withStyles(styles)(RouteMappingCard));
